import { useState, useEffect } from 'react';
import { stats } from '@/mocks/reviews';

export default function StatsBar() {
  const [counts, setCounts] = useState(stats.map(() => 0));
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    if (hasAnimated) return;
    setHasAnimated(true);

    const targets = stats.map((s) => {
      const num = parseInt(s.value.replace(/[^0-9.]/g, ''), 10);
      return num;
    });

    const duration = 2000;
    const steps = 60;
    const interval = duration / steps;
    let step = 0;

    const timer = setInterval(() => {
      step++;
      const progress = step / steps;
      const eased = 1 - Math.pow(1 - progress, 3);
      setCounts(targets.map((t) => Math.round(t * eased)));

      if (step >= steps) {
        setCounts(targets);
        clearInterval(timer);
      }
    }, interval);

    return () => clearInterval(timer);
  }, [hasAnimated]);

  const formatValue = (original: string, count: number): string => {
    if (original.includes('+')) return count.toLocaleString() + '+';
    if (original.includes('%')) return count + '%';
    return count.toLocaleString();
  };

  return (
    <section className="w-full bg-background-50 border-b border-background-200/70">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-10 md:py-12">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={stat.label} className="text-center">
              <div className="w-10 h-10 mx-auto mb-3 rounded-xl bg-primary-50 flex items-center justify-center">
                <i className={`${stat.icon} text-primary-500 text-lg`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-1">
                {formatValue(stat.value, counts[index])}
              </div>
              <div className="text-foreground-500 text-sm">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}